import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.sub.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.isClienteRevenda ? _c('b-row', [_c('div', {
    staticClass: "card-form"
  }, [_c('div', {
    staticClass: "card-list"
  }, [_c('div', {
    staticClass: "card-form-assinatura__inner"
  }, [_c('div', {
    staticClass: "card-input",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('h3', [_vm._v("Verifique sua assinatura com nosso Parceiro:")]), _c('br'), _c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.dadosRevenda.nome_revenda) + " "), _c('br'), _vm._v(" Telefone: " + _vm._s(_vm.dadosRevenda.fone_revenda) + " ")])])])])])]) : _vm._e(), _c('b-row', [_vm.ocultaPlans && _vm.idRevenda === 1 ? _c('b-col', {
    staticClass: "justify-content-center",
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    class: {
      'assinatura-page-container': _vm.shouldShowAppsContratadosSection
    }
  }, [_c('div', {
    staticClass: "card-form shadow h-100",
    class: {
      'assinatura-shell-clean': _vm.shouldShowAppsContratadosSection
    }
  }, [_c('div', {
    staticClass: "card-form-assinatura__inner p-4",
    class: {
      'assinatura-shell-clean__inner': _vm.shouldShowAppsContratadosSection
    }
  }, [_c('div', {
    staticClass: "text-center mb-4 assinatura-top-header"
  }, [_c('h6', {
    staticClass: "text-muted"
  }, [_vm._v("Dúvidas? (49) 3550 0600")]), _c('h2', [_vm._v("🚀 Continue crescendo com a Nuts")]), !_vm.shouldShowAppsContratadosSection ? [_c('p', {
    staticClass: "text-muted mb-1"
  }, [_vm._v(" Você está no plano "), _c('strong', [_vm._v(_vm._s(_vm.planoPrincipalNome))])]), _c('p', {
    staticClass: "valor-destaque"
  }, [_vm._v(" R$ " + _vm._s(_vm.formatValorReal(_vm.assinatura.valor)) + " ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Válido até " + _vm._s(_vm.formatDate(_vm.assinatura.data_validade)) + " ")])] : _c('p', {
    staticClass: "text-muted mb-0"
  }, [_vm._v(" Confira os dados do seu plano e dos apps ativos para transparência da cobrança. ")])], 2), _c('div', {
    class: {
      'assinatura-layout': _vm.shouldShowAppsContratadosSection
    }
  }, [_c('div', {
    class: {
      'assinatura-main-column': _vm.shouldShowAppsContratadosSection
    }
  }, [_vm.planoAtual && _vm.showAssinaturaCard && !_vm.assinatura.assinatura_diferenciada ? _c('div', {
    class: {
      'contratacao-bloco renovacao-card': _vm.shouldShowAppsContratadosSection
    }
  }, [_vm.shouldShowAppsContratadosSection ? _c('div', {
    staticClass: "renovacao-header mb-4"
  }, [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Renovar Plano Nuts")]), _c('p', {
    staticClass: "text-muted mb-0"
  }, [_vm._v(" Escolha a forma de pagamento para renovar seu plano anual. ")]), _c('small', {
    staticClass: "renovacao-observacao d-block mt-2"
  }, [_vm._v(" Apps mensais ativos podem ser incorporados ao próximo ciclo anual nesta renovação. ")])]) : _vm._e(), _c('div', {
    staticClass: "assinatura-steps mb-4"
  }, [_c('div', {
    class: ['step-item', {
      active: _vm.step >= 1
    }]
  }, [_vm._v(" 1. Pagamento ")]), _c('div', {
    class: ['step-item', {
      active: _vm.step >= 2
    }]
  }, [_vm._v(" 2. Plugins ")]), _c('div', {
    class: ['step-item', {
      active: _vm.step >= 3
    }]
  }, [_vm._v(" 3. Finalizar ")])]), _c('div', [_vm.step === 1 ? _c('div', [_c('h5', {
    staticClass: "text-center mb-3"
  }, [_vm._v(" Escolha a forma de pagamento ")]), _c('div', {
    staticClass: "pagamentos-grid"
  }, _vm._l(_vm.opcoesOrdenadas, function (opcao, key) {
    return _c('div', {
      key: key,
      staticClass: "payment-card",
      class: {
        selected: _vm.opcaoSelecionada === key
      },
      on: {
        "click": function click($event) {
          return _vm.selecionarOpcao(key);
        }
      }
    }, [_c('div', {
      staticClass: "payment-title"
    }, [_c('span', [_vm._v(_vm._s(opcao.icon))]), _c('strong', [_vm._v(_vm._s(opcao.label))])]), _c('div', {
      staticClass: "price-main"
    }, [opcao.parcela ? [_vm._v(" " + _vm._s(opcao.parcela) + "x de R$ " + _vm._s(_vm.formatValorReal(_vm.valorOpcaoParcelaComApps(opcao))) + " ")] : opcao.mensal ? [_vm._v(" R$ " + _vm._s(_vm.formatValorReal(_vm.valorOpcaoMensalComApps(opcao))) + " / mês ")] : [_vm._v(" R$ " + _vm._s(_vm.formatValorReal(_vm.valorOpcaoTotalComApps(opcao))) + " ")]], 2), opcao.destaque ? _c('small', {
      staticClass: "text-success d-block"
    }, [_vm._v(" " + _vm._s(opcao.destaque) + " ")]) : _vm._e(), opcao.sub ? _c('small', {
      staticClass: "text-muted d-block mt-1"
    }, [_vm._v(" " + _vm._s(opcao.sub) + " ")]) : _vm._e()]);
  }), 0), _c('div', {
    staticClass: "text-center mt-4"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "lg",
      "disabled": !_vm.opcaoSelecionada
    },
    on: {
      "click": function click($event) {
        _vm.step = 2;
      }
    }
  }, [_vm._v(" Continuar → ")])], 1)]) : _vm._e(), _vm.step === 2 ? _c('div', {
    staticClass: "plugins-box mt-4"
  }, [_c('h5', {
    staticClass: "text-center mb-1"
  }, [_vm._v(" 🚀 Turbine seu sistema ")]), _c('p', {
    staticClass: "text-center text-muted mb-4"
  }, [_vm._v(" Aproveite estes recursos extras com desconto exclusivo para clientes Nuts ")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "plugin-card destaque",
    on: {
      "click": function click($event) {
        return _vm.togglePlugin('certificado');
      }
    }
  }, [_c('div', {
    staticClass: "plugin-badge"
  }, [_vm._v(" 🔥 Mais vendido ")]), _c('b-form-checkbox', {
    staticClass: "mb-2",
    attrs: {
      "switch": "",
      "disabled": _vm.isLoading || _vm.pixLoading || _vm.pixConfirmado || _vm.renovacaoConcluida
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    },
    model: {
      value: _vm.plugins.certificado.ativo,
      callback: function callback($$v) {
        _vm.$set(_vm.plugins.certificado, "ativo", $$v);
      },
      expression: "plugins.certificado.ativo"
    }
  }, [_vm._v(" Certificado Digital A1 ")]), _c('div', {
    staticClass: "plugin-price"
  }, [_c('span', {
    staticClass: "old-price"
  }, [_vm._v(" R$ 250,00 ")]), _c('span', {
    staticClass: "new-price"
  }, [_vm._v(" R$ " + _vm._s(_vm.formatValorReal(_vm.plugins.certificado.valor)) + " ")])]), _c('div', {
    staticClass: "plugin-desc"
  }, [_vm._v(" Emita NF-e sem complicação. Instalação automática no sistema. ")])], 1)]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "plugin-card",
    on: {
      "click": function click($event) {
        return _vm.togglePlugin('tef');
      }
    }
  }, [_c('div', {
    staticClass: "plugin-badge blue"
  }, [_vm._v(" 💳 PDV Completo ")]), _c('b-form-checkbox', {
    staticClass: "mb-2",
    attrs: {
      "switch": "",
      "disabled": _vm.isLoading || _vm.pixLoading || _vm.pixConfirmado || _vm.renovacaoConcluida
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    },
    model: {
      value: _vm.plugins.tef.ativo,
      callback: function callback($$v) {
        _vm.$set(_vm.plugins.tef, "ativo", $$v);
      },
      expression: "plugins.tef.ativo"
    }
  }, [_vm._v(" TEF Integrado ")]), _c('div', {
    staticClass: "plugin-price"
  }, [_c('span', {
    staticClass: "new-price"
  }, [_vm._v(" + R$ " + _vm._s(_vm.formatValorReal(_vm.plugins.tef.valor)) + " ")])]), _c('div', {
    staticClass: "plugin-desc"
  }, [_vm._v(" Conecte maquininhas direto no PDV. Mais rapidez no caixa. ")])], 1)])], 1), _c('div', {
    staticClass: "d-flex justify-content-between mt-4"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function click($event) {
        _vm.step = 1;
      }
    }
  }, [_vm._v(" ← Voltar ")]), _c('b-button', {
    attrs: {
      "variant": "success",
      "size": "lg"
    },
    on: {
      "click": function click($event) {
        _vm.step = 3;
      }
    }
  }, [_vm._v(" Continuar → ")])], 1)], 1) : _vm._e(), _vm.step === 3 ? _c('div', [_vm.opcaoSelecionada === 'pix' && _vm.pixGerado && !_vm.pixConfirmado ? _c('div', {
    staticClass: "alert alert-warning d-flex align-items-start mb-3 aviso-pix-pendente"
  }, [_c('div', {
    staticClass: "mr-2",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("⚠️")]), _c('div', [_c('strong', [_vm._v("Pagamento PIX em processamento")]), _c('div', {
    staticClass: "mb-1"
  }, [_vm._v(" Não atualize e não feche esta tela até a confirmação automática do pagamento. ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Assim que identificarmos o pagamento, a renovação será concluída automaticamente. ")])])]) : _vm._e(), _c('div', {
    staticClass: "card-resumo shadow"
  }, [_c('h5', {
    staticClass: "mb-3"
  }, [_vm._v(" Resumo da renovação ")]), _c('div', {
    staticClass: "resumo-item"
  }, [_c('span', [_vm._v("Plano")]), _c('strong', [_vm._v(_vm._s(_vm.planoPrincipalNome))])]), _c('div', {
    staticClass: "resumo-item"
  }, [_c('span', [_vm._v("Plano Nuts")]), _c('strong', [_vm._v("R$ " + _vm._s(_vm.formatValorReal(_vm.valorPlano)) + "/ano")])]), _c('div', {
    staticClass: "resumo-item"
  }, [_c('span', [_vm._v("Apps selecionados")]), _c('strong', [_vm._v(" R$ " + _vm._s(_vm.formatValorReal(_vm.appsPendingRenewalTotalSelecionado)) + "/ano ")])]), _vm.plugins.certificado.ativo ? _c('div', {
    staticClass: "resumo-item"
  }, [_c('span', [_vm._v("Certificado Digital")]), _c('strong', [_vm._v(" R$ " + _vm._s(_vm.formatValorReal(_vm.plugins.certificado.valor)) + " ")])]) : _vm._e(), _vm.plugins.tef.ativo ? _c('div', {
    staticClass: "resumo-item"
  }, [_c('span', [_vm._v("TEF Integrado")]), _c('strong', [_vm._v(" R$ " + _vm._s(_vm.formatValorReal(_vm.plugins.tef.valor)) + " ")])]) : _vm._e(), _c('hr'), _c('div', {
    staticClass: "resumo-total"
  }, [_c('span', [_vm._v("Total da renovação")]), _c('strong', [_vm._v(" R$ " + _vm._s(_vm.formatValorReal(_vm.valorSelecionado)) + " ")])]), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "success",
      "block": "",
      "size": "lg",
      "disabled": !_vm.opcaoSelecionada || _vm.isLoading || _vm.pixLoading || _vm.pixConfirmado || _vm.renovacaoConcluida
    },
    on: {
      "click": _vm.iniciarPagamento
    }
  }, [_vm._v(" " + _vm._s(_vm.renovacaoConcluida ? "Renovação iniciada" : "🚀 Renovar agora") + " ")]), _vm.opcaoSelecionada === 'pix' && _vm.pixGerado ? _c('div', {
    staticClass: "pix-box mt-3 text-center"
  }, [_vm.qrCodePix ? _c('img', {
    staticClass: "pix-qrcode",
    attrs: {
      "src": _vm.qrCodePix
    }
  }) : _vm._e(), _vm.codigoPix ? _c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.copiarPix
    }
  }, [_vm._v(" Copiar PIX ")]) : _vm._e(), _c('div', {
    staticClass: "pix-warning-text mt-3"
  }, [_c('strong', [_vm._v("Importante:")]), _vm._v(" após realizar o pagamento, mantenha esta tela aberta até a confirmação automática. ")]), _vm.pixExpirationDate ? _c('small', {
    staticClass: "text-muted d-block mt-2"
  }, [_vm._v(" Expira em " + _vm._s(_vm.formatDateTime(_vm.pixExpirationDate)) + " ")]) : _vm._e()], 1) : _vm._e(), _vm.opcaoSelecionada && String(_vm.opcaoSelecionada).startsWith('cartao') && _vm.chamaCartao ? _c('div', {
    staticClass: "mt-3"
  }, [_c('CardForm', {
    attrs: {
      "form-data": _vm.formData,
      "plano": _vm.assinatura.plano,
      "valor": _vm.valorSelecionado,
      "id_plan": _vm.assinatura.id_plan,
      "vezesByPlan": _vm.vezesByPlan,
      "isSale": true,
      "apps-renovacao": _vm.appsRenovacaoPayload()
    },
    on: {
      "card-success": _vm.handleCardSuccess,
      "input-card-number": _vm.updateCardNumber,
      "input-card-name": _vm.updateCardName,
      "input-card-month": _vm.updateCardMonth,
      "input-card-year": _vm.updateCardYear,
      "input-card-cvv": _vm.updateCardCvv
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "text-center mt-4"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function click($event) {
        _vm.step = 2;
      }
    }
  }, [_vm._v(" ← Voltar ")])], 1)]) : _vm._e()])]) : _vm._e(), _vm.shouldShowAppsContratadosSection && _vm.appsPendingRenewalNormalizados.length ? _c('div', {
    staticClass: "contratacao-bloco apps-pending-renewal-card mt-4"
  }, [_c('div', {
    staticClass: "apps-pending-renewal-header"
  }, [_c('div', [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Apps ativos para incluir na renovação")]), _c('p', {
    staticClass: "text-muted mb-0"
  }, [_vm._v(" Estes apps estão ativos na sua empresa. Mantenha selecionados os que deseja incluir no próximo ciclo anual. ")])])]), _c('div', {
    staticClass: "apps-pending-renewal-list"
  }, _vm._l(_vm.appsPendingRenewalNormalizados, function (app) {
    return _c('div', {
      key: app.id,
      staticClass: "app-pending-renewal-item"
    }, [_c('b-form-checkbox', {
      staticClass: "app-pending-renewal-checkbox mb-0",
      attrs: {
        "checked": _vm.isAppPendingRenewalSelected(app.code),
        "disabled": _vm.isLoading || _vm.pixLoading || _vm.pixConfirmado || _vm.renovacaoConcluida
      },
      on: {
        "change": function change($event) {
          return _vm.toggleAppPendingRenewal(app.code, $event);
        }
      }
    }, [_c('span', {
      staticClass: "app-pending-renewal-name"
    }, [_vm._v(_vm._s(app.nome))])]), _c('div', {
      staticClass: "app-pending-renewal-price"
    }, [_vm._v(" " + _vm._s(_vm.appPendingRenewalPriceLabel(app)) + " ")])], 1);
  }), 0), _c('div', {
    staticClass: "apps-pending-renewal-summary"
  }, [_c('div', {
    staticClass: "resumo-total resumo-total--mensal resumo-total--apps-pending"
  }, [_c('span', [_vm._v("Total anual dos apps selecionados:")]), _c('strong', [_vm._v("R$ " + _vm._s(_vm.formatValorReal(_vm.appsPendingRenewalTotalSelecionado)) + "/ano")])])])]) : _vm._e(), _vm.shouldShowAppsContratadosSection && _vm.itemsTable.length ? _c('div', {
    staticClass: "card-form shadow-sm faturas-card faturas-card--inside-main mt-4"
  }, [_c('div', {
    staticClass: "card-form-assinatura__inner p-4"
  }, [_c('b-table', {
    attrs: {
      "items": _vm.itemsTable,
      "fields": _vm.fieldsAssinaturas,
      "small": "",
      "responsive": "",
      "busy": _vm.assinaturasLoading
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center w-100 my-3"
        }, [_c('b-spinner', {
          staticClass: "mr-2",
          attrs: {
            "small": ""
          }
        }), _vm._v(" Carregando faturas... ")], 1)];
      },
      proxy: true
    }, {
      key: "cell(data_vencimento)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(row.item.data_vencimento)) + " ")];
      }
    }, {
      key: "cell(valor)",
      fn: function fn(row) {
        return [_vm._v(" R$ " + _vm._s(_vm.formatValorReal(row.item.valor)) + " ")];
      }
    }, {
      key: "cell(status)",
      fn: function fn(row) {
        return [_c('b-badge', {
          staticClass: "fatura-status-badge",
          attrs: {
            "variant": _vm.getFaturaStatusMeta(row.item).variant
          }
        }, [_vm._v(" " + _vm._s(_vm.getFaturaStatusMeta(row.item).label) + " ")])];
      }
    }, {
      key: "cell(acoes)",
      fn: function fn(row) {
        return [row.item.url_boleto && !row.item.pagamento && !row.item.cancelado ? _c('b-button', {
          attrs: {
            "href": row.item.url_boleto,
            "target": "_blank",
            "size": "sm",
            "variant": "outline-primary"
          }
        }, [_vm._v(" Abrir boleto ")]) : _vm._e()];
      }
    }], null, false, 3589769797)
  })], 1)]) : _vm._e()]), _vm.shouldShowAppsContratadosSection ? _c('div', {
    staticClass: "assinatura-side-column"
  }, [_c('div', {
    staticClass: "contratacao-bloco plano-principal-card mb-3"
  }, [_c('h5', {
    staticClass: "mb-2"
  }, [_vm._v("Plano Nuts")]), _c('p', {
    staticClass: "plano-principal-nome mb-2"
  }, [_vm._v(_vm._s(_vm.planoPrincipalNome))]), _c('p', {
    staticClass: "valor-destaque valor-destaque--small mb-3"
  }, [_vm._v(" R$ " + _vm._s(_vm.formatValorReal(_vm.planoPrincipalAnual)) + " "), _c('span', [_vm._v("/ano")])]), _c('p', {
    staticClass: "mb-1"
  }, [_c('strong', [_vm._v("Cobrança:")]), _vm._v(" Anual")]), _c('p', {
    staticClass: "mb-1"
  }, [_c('strong', [_vm._v("Status:")]), _vm._v(" " + _vm._s(_vm.planoPrincipalStatusLabel))]), _c('p', {
    staticClass: "mb-0"
  }, [_c('strong', [_vm._v("Vencimento:")]), _vm._v(" " + _vm._s(_vm.formatDate(_vm.assinatura.data_validade)))])]), _c('div', {
    staticClass: "contratacao-bloco apps-contratados-card mb-3"
  }, [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Apps contratados")]), _c('p', {
    staticClass: "text-muted mb-3"
  }, [_vm._v("Módulos e plugins ativos na sua empresa.")]), _vm.appsContratadosNormalizados.length ? _c('div', _vm._l(_vm.appsContratadosNormalizados, function (app) {
    return _c('div', {
      key: app.id,
      staticClass: "app-contratado-item"
    }, [_c('p', {
      staticClass: "mb-1"
    }, [_c('strong', [_vm._v(_vm._s(app.nome))])]), _c('p', {
      staticClass: "mb-1 app-tipo-label"
    }, [_vm._v(_vm._s(app.tipoLabel))]), app.shouldShowIncluso ? _c('p', {
      staticClass: "mb-1"
    }, [_c('strong', [_vm._v("Incluso")])]) : app.quantity > 1 ? _c('p', {
      staticClass: "mb-1"
    }, [_vm._v(" " + _vm._s(app.quantity) + " " + _vm._s(app.quantityLabel) + " x R$ " + _vm._s(_vm.formatValorReal(app.unitPrice)) + " = R$ " + _vm._s(_vm.formatValorReal(app.totalPrice)) + "/mês ")]) : _c('p', {
      staticClass: "mb-1"
    }, [_vm._v(" R$ " + _vm._s(_vm.formatValorReal(app.totalPrice)) + "/mês ")]), app.showSourceLine ? _c('p', {
      staticClass: "mb-0 text-muted"
    }, [_vm._v(_vm._s(app.sourceLabel))]) : _vm._e()]);
  }), 0) : _c('div', {
    staticClass: "sem-apps-box sem-apps-box--highlight"
  }, [_c('p', {
    staticClass: "mb-1"
  }, [_c('strong', [_vm._v("Você ainda não possui apps adicionais contratados.")])]), _c('p', {
    staticClass: "mb-3 text-muted"
  }, [_vm._v(" Explore o Marketplace para conhecer módulos e plugins que podem complementar sua operação. ")]), _c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "href": "/#/apps"
    }
  }, [_vm._v(" Conhecer Marketplace ")])], 1)]), _c('div', {
    staticClass: "contratacao-bloco resumo-financeiro-card"
  }, [_c('h5', {
    staticClass: "mb-2"
  }, [_vm._v("Resumo da renovação")]), _c('div', {
    staticClass: "resumo-item"
  }, [_c('span', [_vm._v("Plano Nuts:")]), _c('strong', [_vm._v("R$ " + _vm._s(_vm.formatValorReal(_vm.valorPlanoResumoRenovacao)) + "/ano")])]), _c('div', {
    staticClass: "resumo-item"
  }, [_c('span', [_vm._v("Apps selecionados:")]), _c('strong', [_vm._v("R$ " + _vm._s(_vm.formatValorReal(_vm.appsPendingRenewalTotalSelecionado)) + "/ano")])]), _vm.valorPlugins ? _c('div', {
    staticClass: "resumo-item"
  }, [_c('span', [_vm._v("Plugins extras:")]), _c('strong', [_vm._v("R$ " + _vm._s(_vm.formatValorReal(_vm.valorPlugins)))])]) : _vm._e(), _c('div', {
    staticClass: "resumo-total resumo-total--mensal"
  }, [_c('span', [_vm._v("Total da renovação:")]), _c('strong', [_vm._v("R$ " + _vm._s(_vm.formatValorReal(_vm.totalRenovacaoResumo)))])])])]) : _vm._e()])])])])]) : _vm._e()], 1), _vm.ocultaPlans && _vm.idRevenda === 1 && _vm.itemsTable.length && !_vm.shouldShowAppsContratadosSection ? _c('b-row', {
    staticClass: "mt-4 justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "md": "12",
      "lg": _vm.shouldShowAppsContratadosSection ? 12 : 8
    }
  }, [_c('div', {
    class: {
      'assinatura-page-container': _vm.shouldShowAppsContratadosSection
    }
  }, [_c('div', {
    staticClass: "card-form shadow-sm",
    class: {
      'bloco-faturas': !_vm.shouldShowAppsContratadosSection,
      'faturas-card': _vm.shouldShowAppsContratadosSection
    }
  }, [_c('div', {
    staticClass: "card-form-assinatura__inner p-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-3 faturas-header"
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v("Faturas")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Histórico de cobrança")])]), _c('b-table', {
    attrs: {
      "items": _vm.itemsTable,
      "fields": _vm.fieldsAssinaturas,
      "small": "",
      "responsive": "",
      "busy": _vm.assinaturasLoading
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center w-100 my-3"
        }, [_c('b-spinner', {
          staticClass: "mr-2",
          attrs: {
            "small": ""
          }
        }), _vm._v(" Carregando faturas... ")], 1)];
      },
      proxy: true
    }, {
      key: "empty",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center text-muted my-3"
        }, [_vm._v(" Nenhuma fatura encontrada. ")])];
      },
      proxy: true
    }, {
      key: "cell(data_vencimento)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(row.item.data_vencimento)) + " ")];
      }
    }, {
      key: "cell(valor)",
      fn: function fn(row) {
        return [_vm._v(" R$ " + _vm._s(_vm.formatValorReal(row.item.valor)) + " ")];
      }
    }, {
      key: "cell(status)",
      fn: function fn(row) {
        return [_c('b-badge', {
          staticClass: "fatura-status-badge",
          attrs: {
            "variant": _vm.getFaturaStatusMeta(row.item).variant
          }
        }, [_vm._v(" " + _vm._s(_vm.getFaturaStatusMeta(row.item).label) + " ")])];
      }
    }, {
      key: "cell(acoes)",
      fn: function fn(row) {
        return [row.item.url_boleto && !row.item.pagamento && !row.item.cancelado ? _c('b-button', {
          attrs: {
            "href": row.item.url_boleto,
            "target": "_blank",
            "size": "sm",
            "variant": "outline-primary"
          }
        }, [_vm._v(" Abrir boleto ")]) : _vm._e()];
      }
    }], null, false, 1801424614)
  })], 1)])])])], 1) : _vm._e(), _vm.dataReady && !_vm.ocultaPlans && !_vm.isRevenda && !_vm.isClienteRevenda && !_vm.assinatura.assinatura_diferenciada && !_vm.isNuts ? _c('b-row', {
    staticClass: "plan__table"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "plan-picker card-form shadow p-3 plan-card--alert"
  }, [_c('div', {
    staticClass: "plan-card__header bg-warning text-dark"
  }, [_c('h5', {
    staticClass: "m-0"
  }, [_vm._v("⚠ Você ainda está sem plano")])]), _c('div', {
    staticClass: "plan-card__body"
  }, [_c('p', {
    staticClass: "mb-3"
  }, [_vm._v(" Identificamos que sua empresa ainda não possui um plano ativo. Para continuar utilizando o sistema, verifique sua assinatura com a Nuts. ")]), _c('b-button', {
    attrs: {
      "variant": "success",
      "block": ""
    },
    on: {
      "click": _vm.abrirWhatsApp
    }
  }, [_vm._v(" Falar com a Nuts no WhatsApp ")])], 1)])])], 1) : _vm._e(), _vm.isRevenda && _vm.idRevenda === 1 ? _c('b-row', [_c('b-col', {
    staticClass: "justify-content-center",
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "card-form shadow h-100"
  }, [_c('div', {
    staticClass: "card-form-assinatura__inner p-4"
  }, [_c('div', {
    staticClass: "text-center mb-4"
  }, [_c('h6', {
    staticClass: "text-muted"
  }, [_vm._v("Dúvidas? (49) 3550 0600")]), _c('h2', [_vm._v("🚀 Continue crescendo com a Nuts")]), _c('p', {
    staticClass: "text-muted mb-1"
  }, [_vm._v(" Você está no plano "), _c('strong', [_vm._v(_vm._s(_vm.assinatura.plano))])]), _c('p', {
    staticClass: "valor-destaque"
  }, [_vm._v(" R$ " + _vm._s(_vm.formatValorReal(_vm.assinatura.valor)) + " ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Válido até " + _vm._s(_vm.formatDate(_vm.assinatura.data_validade)) + " ")])])])])])], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };